// extracted by mini-css-extract-plugin
module.exports = {"times":"MainTable_times__304o0"};